var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tower",class:_vm.classes},[_c('blocks-list',{attrs:{"blocks":_vm.page.blocks}}),(_vm.page.newsletter)?_c('newsletter',{attrs:{"block":_vm.newsletterBlock}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }